import React from "react";

export default function ChatMessageInput({ text, onChange, onSend }) {
  return (
    <div className="p-4 bg-white border-t flex gap-2">
      <input
        className="flex-1 input input-bordered"
        value={text}
        onChange={onChange}
        placeholder="Écrire un message…"
      />
      <button className="btn btn-primary" onClick={onSend}>
        Envoyer
      </button>
    </div>
  );
}
